import { computed } from 'vue';
import { usePolicy } from 'dashboard/composables/usePolicy';

/**
 * Thin wrapper over usePolicy for the org chart permission keys.
 * Administrators always pass, so every check is "administrator OR the key".
 */
export function useOrgPermissions() {
  const { checkPermissions } = usePolicy();

  const can = permission => checkPermissions(['administrator', permission]);

  return {
    can,
    canDeleteConversation: computed(() => can('conversation_delete')),
    canDeleteMessage: computed(() => can('message_delete')),
    canAssignConversation: computed(() => can('conversation_assign')),
    canSelfAssignConversation: computed(() =>
      checkPermissions([
        'administrator',
        'conversation_assign',
        'conversation_self_assign',
      ])
    ),
    canTransferTeam: computed(() => can('conversation_transfer_team')),
    canReply: computed(() => can('conversation_reply')),
    canAddNote: computed(() => can('conversation_note')),
    canChangeStatus: computed(() => can('conversation_change_status')),
    canChangePriority: computed(() => can('conversation_change_priority')),
    canSendTranscript: computed(() => can('conversation_send_transcript')),
    canMuteConversation: computed(() => can('conversation_mute')),
    canImportContacts: computed(() => can('contact_import')),
    canDeleteContacts: computed(() => can('contact_delete')),
    canEditContacts: computed(() => can('contact_edit')),
    canCreateContacts: computed(() => can('contact_create')),
    canManageLabels: computed(() => can('conversation_manage_labels')),
    canExportContacts: computed(() => can('contact_export')),
  };
}
